
import React from "react";

export const variantOptionColumns = [
  {
    key: "option_name",
    label: "Option Name",
  },
  {
    key: "option_value",
    label: "Option Value",
  },
  {
    key: "image_url",
    label: "Image",
    render: (variantOption: any) => {
      if (!variantOption.image_url) {
        return <span className="text-muted-foreground">No image</span>;
      }
      
      return (
        <div className="flex items-center">
          <img
            src={variantOption.image_url}
            alt={variantOption.option_value}
            className="w-10 h-10 object-cover rounded-md border"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
              const nextElement = target.nextElementSibling as HTMLElement | null;
              if (nextElement) {
                nextElement.style.display = 'inline';
              }
            }}
          />
          <span className="text-muted-foreground text-xs ml-2" style={{ display: 'none' }}>
            Image not found
          </span>
        </div>
      );
    },
  },
  {
    key: "is_default",
    label: "Default",
    render: (variantOption: any) => {
      return variantOption.is_default ? (
        <span className="bg-primary/10 text-primary px-2 py-1 rounded-md text-xs">Yes</span>
      ) : (
        <span className="text-muted-foreground">No</span>
      );
    },
  },
  {
    key: "variant_names",
    label: "Associated Variants",
    render: (variantOption: any) => {
      if (!variantOption.variant_names || variantOption.variant_names.length === 0) {
        return <span className="text-muted-foreground">None</span>;
      }
      
      return (
        <div className="flex flex-wrap gap-1">
          {variantOption.variant_names.map((variantName: string, index: number) => {
            // Capitalize and remove underscores from variant names
            const formattedName = variantName
              ?.replace(/_/g, ' ')
              ?.split(' ')
              ?.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
              ?.join(' ');
            
            return (
              <span key={index} className="bg-secondary text-secondary-foreground px-2 py-1 rounded-md text-xs">
                {formattedName || variantName}
              </span>
            );
          })}
        </div>
      );
    },
  },
  {
    key: "factories",
    label: "Associated Factories",
    render: (variantOption: any) => {
          if (variantOption.is_default) {
      return <span className="text-muted-foreground">All factories</span>;
    }
      if (!variantOption.factories || variantOption.factories.length === 0) {
        return <span className="text-muted-foreground">None</span>;
      }
      
      return (
        <div className="flex flex-wrap gap-1">
          {variantOption.factories.map((factory: string, index: number) => (
            <span key={index} className="bg-primary/10 text-primary px-2 py-1 rounded-md text-xs">
              {factory}
            </span>
          ))}
        </div>
      );
    },
  },
];
